// lib
import React from 'react'
import { RouteComponentProps } from 'react-router'

// components
import BackbuttonHeader from 'src/components/header/common/backbutton_header/backbutton_header'
import MetaTags from 'src/components/meta_tags/meta_tags'
import StandardPageTitle from 'src/containers/smart_components/page_title/page_title'

// constants & interfaces
import {
  INFRASTRUCTURE_PROJECTSFEED_DESCRIPTION,
  INFRASTRUCTURE_PROJECTSFEED_TITLE,
  PROJECTSFEED_DESCRIPTION,
  PROJECTSFEED_TITLE
} from 'src/constants/meta_tags'

// helpers
import { ProjectType } from '@lopo-tech/lopo-api'
import MyProjectList from 'src/components/projects/my_project_list/my_project_list'
import { getProjectRoutes } from 'src/constants/urls'
import { textResources } from 'src/lang/de'
import { useGetAppLocationShape } from 'src/reducers/app-state/app-state_hooks'
import { UrlUtils } from 'src/utils/url/url'
import LayoutNoMap from '../layout/layout_no_map'

const t = textResources.projects

interface IProps extends RouteComponentProps {
  projectType: ProjectType;
}

export const ProjectsMyListPage: React.FC<IProps> = ({ history, projectType }) => {
  const locationShape = useGetAppLocationShape()
  const isInfrastructureProject = projectType === ProjectType.InfrastructureProject
  const titleResolver = isInfrastructureProject ? INFRASTRUCTURE_PROJECTSFEED_TITLE : PROJECTSFEED_TITLE
  const descriptionResolver = isInfrastructureProject ? INFRASTRUCTURE_PROJECTSFEED_DESCRIPTION : PROJECTSFEED_DESCRIPTION
  const title = locationShape ? titleResolver(locationShape.name) : undefined
  const description = locationShape ? descriptionResolver(locationShape.name) : undefined
  const routes = getProjectRoutes(projectType)

  const fallbackRoute = locationShape ? routes.overview(locationShape.slug) : '/'

  const goBack = () => {
    UrlUtils.goBack(history, fallbackRoute)
  }

  return (
    <>
      <MetaTags
        description={description}
        geo_placename={locationShape?.name}
        geo_position={
          locationShape &&
          `${locationShape.center.latitude};${locationShape.center.longitude}`
        }
        og_url={document.location.toString()}
        title={title}
      />
      <LayoutNoMap
        subHeader={
          <BackbuttonHeader
            title={t.overview.sectionMyProjects}
            handleBackButton={goBack}
          />
        }
        pageTitle={
          <StandardPageTitle
            text={isInfrastructureProject ? t.common.infrastructureProjects : t.common.projects}
            showLocation
          />
        }
        withHeaderMargin
      >
        <MyProjectList projectType={projectType} />
      </LayoutNoMap>
    </>
  )
}

const PublicParticipationProjectsMyListPage: React.FC<RouteComponentProps> = (props) => (
  <ProjectsMyListPage {...props} projectType={ProjectType.PublicParticipationProject} />
)

export default PublicParticipationProjectsMyListPage
